import { useCallback } from 'react'
import { Heading, Flex, Box, Button, Card } from 'ui'
import { useNavigate } from 'react-router'

type ScheduleShiftNavigatorProps = {
  worker: {
    id: number
    name?: string
  } | null
}

/**
 * Navigates to the shift scheduler.
 * If a worker ID is provided, the scheduler will have the worker pre-selected.
 * If no worker is specified, the user will be prompted to select a worker in the scheduler.
 */
export const ScheduleShiftNavigator = ({
  worker,
}: ScheduleShiftNavigatorProps) => {
  const navigate = useNavigate()

  const workerName = worker?.name || 'a worker'
  const queryParams = worker?.id ? `&worker_ids=${worker.id}` : ''

  const handleCreateFutureShift = useCallback(() => {
    navigate(`/home/shift-editor/new?schedule=future${queryParams}`)
  }, [navigate, queryParams])

  const handleCreatePastShift = useCallback(() => {
    navigate(`/home/shift-editor/new?schedule=past${queryParams}`)
  }, [navigate, queryParams])

  return (
    <Box py={4}>
      <Heading level={3} my={0} mb={4} textAlign={'center'}>
        Select a Schedule Option Below
      </Heading>
      <Flex
        flexDirection={'row'}
        flexWrap={'wrap'}
        justifyContent={'space-between'}
      >
        <Card alignItems={'center'} width={[1, 11 / 23]} mb={[4, 0]}>
          <Heading level={4} my={0}>
            Request For Future Shift
          </Heading>
          <Box textAlign={'center'} my={3}>
            Invite {workerName} to a shift with a start time in the future.
          </Box>
          <Button block onClick={handleCreateFutureShift}>
            Create Future Shift
          </Button>
        </Card>
        <Card alignItems={'center'} width={[1, 11 / 23]}>
          <Heading level={4} my={0}>
            Create a Past Shift
          </Heading>
          <Box textAlign={'center'} my={3}>
            Assign {workerName} to a shift with a start time in the past.
          </Box>
          <Button block onClick={handleCreatePastShift}>
            Create Past Shift
          </Button>
        </Card>
      </Flex>
    </Box>
  )
}

export { ScheduleShiftModal } from './ScheduleShiftModal'
